import React, { createContext, useContext } from 'react';
import useOnlineStatus from './useOnlineStatus';
import { BANNER_HEIGHT } from './OfflineBanner';

export const OnlineStatusContext = createContext({ isOnline: true, justReconnected: false, bannerOffset: 0 });

export const OnlineStatusProvider = ({ children }) => {
  const { isOnline, justReconnected } = useOnlineStatus();
  const bannerOffset = (!isOnline || justReconnected) ? BANNER_HEIGHT : 0;

  return (
    <OnlineStatusContext.Provider value={{ isOnline, justReconnected, bannerOffset }}>
      {children}
    </OnlineStatusContext.Provider>
  );
};

export const useOnlineStatusContext = () => useContext(OnlineStatusContext);
